import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import SectionHeading from "@/components/base/SectionHeading";
import CompanySubNav from "@/pages/company/components/CompanySubNav";

const ACCESS_ROWS = [
  { label: "法人名", value: "REVRA Group" },
  { label: "住所", value: "未定（決定次第、改めてご案内いたします）" },
  { label: "アクセス", value: "詳細は決定次第掲載いたします" },
  { label: "設立年月日", value: "2026年内目処" },
];

export default function CompanyAccess() {
  return (
    <div className="w-full bg-background-50">
      <PageHero
        en="ACCESS"
        ja="アクセス"
        crumbs={[{ label: "企業情報", path: "/company" }, { label: "アクセス" }]}
      />
      <CompanySubNav />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <SectionHeading label="アクセス" en="Access" />
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
              <div>
                <dl className="border-t border-background-300/70">
                  {ACCESS_ROWS.map((row) => (
                    <div
                      key={row.label}
                      className="flex flex-col gap-1 border-b border-background-300/70 py-5"
                    >
                      <dt className="font-label text-xs tracking-[0.24em] text-secondary-500">
                        {row.label}
                      </dt>
                      <dd className="font-body text-sm leading-[1.9] text-foreground-950">
                        {row.value}
                      </dd>
                    </div>
                  ))}
                </dl>
                <p className="mt-8 font-body text-sm leading-[2] text-foreground-600">
                  所在地・連絡先が決定次第、本ページにてご案内いたします。
                  お問い合わせはフォームより承っております。
                </p>
              </div>

              <div className="h-[320px] w-full overflow-hidden border border-background-300/70 md:h-[480px]">
                <iframe
                  title="REVRA Group 所在地マップ"
                  src="https://maps.google.com/maps?q=%E6%9D%B1%E4%BA%AC%E9%83%BD&t=&z=11&ie=UTF8&iwloc=&output=embed"
                  className="h-full w-full"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}